// extracted by mini-css-extract-plugin
export default {"commands-wrapper":"ZUAX","commandsWrapper":"ZUAX","maximize":"QOCk","command":"DXk3"};